import { z } from 'zod';
import {
  MESSAGE_FIN_AVANT_DEBUT,
  dateReelleSchema,
  finApresDebut,
  heureReelleSchema,
} from './comprehension.js';

// Modifier une chose DEJA dans le planning (lot E, 2026-08-27).
//
// Les formats sont ceux de la creation (importes et non recopies) : deux regex jumelles
// divergeraient un jour en silence. Ce sont les schemas STRICTS : ce qu'un humain saisit
// doit exister — un 31 fevrier etait range au 3 mars sans un mot (audit du 2026-09-27).
//
// Tous les champs sont FACULTATIFS : le corps ne porte que ce que l'utilisateur a change,
// et le serveur reconstruit le reste depuis l'existant. Un corps vide est refuse — une
// modification qui ne modifie rien est une erreur d'appel, pas une operation valide.

export const modificationEvenementSchema = z
  .object({
    title: z.string().trim().min(1, 'Le titre est obligatoire').max(200).optional(),
    date: dateReelleSchema.optional(),
    /** null = journee entiere. */
    time: heureReelleSchema.nullable().optional(),
    endTime: heureReelleSchema.nullable().optional(),
    location: z.string().trim().max(200).nullable().optional(),
    /** Comment on s'y rend : « RER B », « TER Amiens-Paris ». `null` efface. */
    transport: z.string().trim().max(80).nullable().optional(),
  })
  .refine((valeur) => Object.keys(valeur).length > 0, { message: 'Rien à modifier' })
  // Le schema ne juge que ce qu'il VOIT : les deux heures donnees ensemble. Quand une
  // seule arrive, l'autre est en base — c'est la route qui compare (routes/edition.ts).
  .refine(
    (valeur) =>
      valeur.time === undefined ||
      valeur.endTime === undefined ||
      finApresDebut(valeur.time, valeur.endTime),
    { message: MESSAGE_FIN_AVANT_DEBUT, path: ['endTime'] },
  );

export type ModificationEvenement = z.infer<typeof modificationEvenementSchema>;

export const modificationTacheSchema = z
  .object({
    title: z.string().trim().min(1, 'Le titre est obligatoire').max(200).optional(),
    /** null = sans echeance (la tache passe dans « Sans date »). */
    dueDate: dateReelleSchema.nullable().optional(),
  })
  .refine((valeur) => Object.keys(valeur).length > 0, { message: 'Rien à modifier' });

export type ModificationTache = z.infer<typeof modificationTacheSchema>;

export const modificationRappelSchema = z
  .object({
    message: z.string().trim().min(1, 'Le message est obligatoire').max(300).optional(),
    date: dateReelleSchema.optional(),
    time: heureReelleSchema.optional(),
  })
  .refine((valeur) => Object.keys(valeur).length > 0, { message: 'Rien à modifier' });

export type ModificationRappel = z.infer<typeof modificationRappelSchema>;

export const renommageSchema = z.object({
  title: z.string().trim().min(1, 'Le titre est obligatoire').max(200),
});

export const libelleElementSchema = z.object({
  label: z.string().trim().min(1, 'Un élément ne peut pas être vide').max(120),
});
